import { useState, useRef, useEffect } from 'react';
import React from "react";
import './Leaverequest.css';
import axios from 'axios';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { cancelLeaveRequestr, createLeaveRequest, getApprovedLeavesBasedonEmployeeId, getLeaveBalanceByEmployeeId, getLeavesBasedonEmployeeId, getLeavesByEmployeeId, updateLeavesRequest } from '../../../services/leaveService';
import { useNavigate } from 'react-router-dom';

const LeaveRequest = () => {
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [leaveDate, setLeaveDate] = useState('');
  const [reason, setReason] = useState('');
  const [leaveList, setLeaveList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [remainingLeaves, setRemainingLeaves] = useState('');
  const [getAllHolidays, setGetAllHolidays] = useState([]); // Make sure this is initialized as an empty array
  const [totalLeaves, setTotalLeaves] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLeaveId, setEditLeaveId] = useState(null); // Store leave ID for update
  const [approvedLeaves, setApprovedLeaves] = useState([]);
  const [approvedLeaveId, setApprovedLeaveId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchAllHolidaysLeave();
    fetchAllHolidays();
    fetchApprovedLeaves(); // add this
  }, []);
  const leaveTypeOptions = [
    { value: 'casual', label: 'Casual' },
    { value: 'sick', label: 'Sick' }
  ];

  const handleToggleForm = () => {
    setShowForm(!showForm);
    setIsEditMode(false);
    setEditLeaveId(null);
    clearForm(); // reset form fields
  };

  const clearForm = () => {
    setLeaveDate('');
    setSelectedLeaveType(null);
    setReason('');
    setSelectedDate(null);
    setSelectedEndDate(null);
  };

  const dateInputRef = useRef(null);
  const handleDateInputClick = () => {
    dateInputRef.current.showPicker(); // Show the calendar for date input field
  };

  // const handleEditClick = (leave) => {
  //   setIsEditMode(true);
  //   setEditLeaveId(leave.id); // This is crucial
  //   setSelectedDate(new Date(leave.fromDate));
  //   setSelectedEndDate(new Date(leave.toDate));
  //   setSelectedLeaveType({ value: leave.type.toLowerCase(), label: leave.type });
  //   setReason(leave.reason);
  //   setShowForm(true);
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!selectedDate || !selectedEndDate || !selectedLeaveType || reason.trim() === '') {
  //     alert("Please fill all fields");
  //     return;
  //   }
  //   const fullNameAudit = localStorage.getItem("full_name");
  //   //const role = localStorage.getItem("role");
  //   //const employeeIdAudit = localStorage.getItem("employeeId");

  //   let payload = {
  //     // id: editLeaveId, // ✅ ADD this to ensure update works
  //     //approvedId: approvedLeaveId, // ✅ use a separate state for approved leave if applicable
  //     employeeId: employeeId,
  //     employeeName: name,
  //     fromDate: format(selectedDate, 'yyyy-MM-dd'),
  //     toDate: format(selectedEndDate, 'yyyy-MM-dd'),
  //     // daysApplied: Math.floor((selectedEndDate - selectedDate) / (1000 * 60 * 60 * 24)) + 1,
  //     type: selectedLeaveType.label,
  //     reason: reason,
  //     auditlog: {
  //       name: fullNameAudit,
  //       role: role,
  //       employeeId: employeeId,
  //     },
  //   };
  //   if (isEditMode && editLeaveId !== null) {
  //     payload = { ...payload, id: editLeaveId };
  //   }
  //   try {
  //     if (isEditMode && editLeaveId !== null) {
  //       // Update approved leave
  //       const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/update-leave`, payload, {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //       );
  //       alert("Approved leave updated successfully!");
  //     } else {
  //       // New leave request
  //       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/apply`, payload,
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //         }
  //       );

  //       if (response.status === 200 || response.status === 201) {
  //         alert("Approved leave updated successfully!");
  //         const { remainingLeaves } = response.data;
  //         setLeaveList((prev) => [...prev, payload]);
  //         setRemainingLeaves(remainingLeaves);
  //       }
  //     }

  //     clearForm();
  //     setShowForm(false);
  //     setIsEditMode(false);
  //     setEditLeaveId(null);
  //     fetchAllHolidays();
  //     fetchAllHolidaysLeave();
  //     fetchApprovedLeaves();
  //   } catch (error) {
  //     if (error.response && error.response.data.error) {
  //       alert(error.response.data.error);  // Show backend error message
  //     } else {
  //       alert('An unexpected error occurred. Please try again later.');
  //     }
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedDate || !selectedEndDate || !selectedLeaveType) {
      alert("Please fill all fields");
      return;
    }

    const fullNameAudit = localStorage.getItem("full_name");
    // const role = localStorage.getItem("role");
    // const employeeIdAudit = localStorage.getItem("employeeId");

    let payload;

    if (isEditMode && editLeaveId !== null) {
      // --- Update Leave Payload ---
      payload = {
        employeeId: employeeId,
        leaveId: editLeaveId,   // Important: backend expects leaveId
        fromDate: format(selectedDate, 'yyyy-MM-dd'),
        toDate: format(selectedEndDate, 'yyyy-MM-dd'),
        reason: reason,
        auditlog: {
          name: fullNameAudit,
          role: role,
          employeeId: employeeId,
        },
      };

      try {
        // await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/update-leave`, payload, {
        //   headers: { 'Content-Type': 'application/json' },
        // });
        await updateLeavesRequest(payload);
        alert("Leave updated successfully!");
      } catch (error) {
        if (error.response && error.response.data.error) {
          alert(error.response.data.error);
        } else {
          alert('An unexpected error occurred. Please try again later.');
        }
      }
    } else {
      // --- Apply New Leave Payload ---
      payload = {
        employeeId: employeeId,
        employeeName: name,
        fromDate: format(selectedDate, 'yyyy-MM-dd'),
        toDate: format(selectedEndDate, 'yyyy-MM-dd'),
        type: selectedLeaveType.label,
        reason: reason,
        auditlog: {
          name: fullNameAudit,
          role: role,
          employeeId: employeeId,
        },
      };

      try {

        //const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/apply`, payload, {headers: { 'Content-Type': 'application/json' },});
        const response = await createLeaveRequest(payload);

        if (response.status === 200 || response.status === 201) {
          alert("Leave applied successfully!");
          const { remainingLeaves } = response.data;
          setLeaveList((prev) => [...prev, payload]);
          setRemainingLeaves(remainingLeaves);
        }
      } catch (error) {
        if (error.response && error.response.data.error) {
          alert(error.response.data.error);
        } else {
          alert('An unexpected error occurred. Please try again later.');
        }
      }
    }

    // Clear form & refresh data
    clearForm();
    setShowForm(false);
    setIsEditMode(false);
    setEditLeaveId(null);
    fetchAllHolidays();
    fetchAllHolidaysLeave();
    fetchApprovedLeaves();
  };

  const fetchAllHolidays = async () => {
    try {

      // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/balance/${employeeId}`);
      const data = await getLeaveBalanceByEmployeeId(employeeId)

      setRemainingLeaves(data.availableLeaves);
      // setTotalLeaves(leaveData.leavesBalance); // If you want to show total leaves
      // Optionally store employeeName or employeeId again if needed

    } catch (error) {
      console.error('Error fetching holidays:', error);
    }
  };


  const fetchAllHolidaysLeave = async () => {
    try {

      // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/employee/${employeeId}`);
      const data = await getLeavesBasedonEmployeeId(employeeId);
      if (data && Array.isArray(data)) {
        setGetAllHolidays(data);
      } else {
        console.warn("Unexpected response structure:", data);
        setGetAllHolidays([]);
      }
    } catch (error) {
      console.error('Error fetching leave history:', error);
    }
  };

  // Call fetchAllHolidays when the component mounts
  useEffect(() => {
    fetchAllHolidaysLeave();
    fetchAllHolidays();

  }, []);

  // const fetchApprovedLeaves = async () => {
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/approved/employee/${employeeId}`);
  //     if (response.data && Array.isArray(response.data.leaves)) {
  //       setApprovedLeaves(response.data.leaves);
  //     } else {
  //       console.warn("Unexpected approved leaves structure", response.data);
  //       setApprovedLeaves([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching approved leaves:", error);
  //   }
  // };
  const fetchApprovedLeaves = async () => {
    try {
      // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/approved/employee/${employeeId}`);
      const data = await getApprovedLeavesBasedonEmployeeId(employeeId);
      if (Array.isArray(data)) {
        setApprovedLeaves(data);
      } else {
        console.warn("Unexpected approved leaves structure", data);
        setApprovedLeaves([]);
      }
    } catch (error) {
      console.error("Error fetching approved leaves:", error);
      setApprovedLeaves([]);
    }
  };
  const handleCancelLeave = async (leaveId) => {
    try {
      const payload = {
        name: name,
        role: role,
        employeeId: employeeId,
      };

      // const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/${leaveId}/cancel`,payload);
      const response = await cancelLeaveRequestr(leaveId, payload);
      if (response.status === 200) {
        alert("Leave cancelled successfully!");
        // Optionally refresh table data
        fetchApprovedLeaves();
        fetchAllHolidaysLeave();
      } else {
        alert("Failed to cancel leave. Please try again.");
      }
    } catch (error) {
      console.error("Error cancelling leave:", error);
      alert("An error occurred while cancelling the leave.");
    }
  };

  const gotoDashBoard = () => {
    navigate("/dashboard");
  }

  const name = localStorage.getItem("full_name");
  const employeeId = localStorage.getItem("employeeId");
  const isFormValid = selectedDate && selectedEndDate && selectedLeaveType;
  const role = localStorage.getItem("role");
  console.log('role in leave', role);
  return (
    <React.Fragment>
      <div className='leavemanagement-maincontainer'>
        <div className="leavemanagement-container">
          <div className="leavemanagement-content">
            <h2 className="leaveheading-1">Leave Management</h2>
            <h4 className="leaveheading-2"></h4>
            {/* <div className="leave-button">
              <button type="button" onClick={handleToggleForm}>
                {showForm ? 'Close Form' : 'Apply Leave'}
              </button>
            </div> */}
            <div className="leave-button">
              {!showForm &&
                <button type="button" onClick={handleToggleForm}>
                  {showForm ? 'Close Form' : 'Apply Leave'}
                </button>

              }

            </div>

            {showForm && (
              <form className="leavemanagement-form" onSubmit={handleSubmit}>
                <div className="leavemanagement-div-floating-label">

                  <input
                    type="text"
                    value={employeeId}
                    readOnly
                    tabIndex={-1}
                    className="readonly-input"
                  />
                  <label> <span className='required'>*</span>Employee ID</label>
                </div>
                <div className="leavemanagement-div-floating-label">

                  <input
                    type="text"
                    value={name}
                    readOnly
                    tabIndex={-1}
                    className="readonly-input"
                  />
                  <label><span className='required'>*</span>Name</label>
                </div>
                <div className="leavemanagement-div-floating-label">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => {
                      setSelectedDate(date);
                      setSelectedEndDate(null);
                    }}
                    minDate={new Date()}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=" " // required to trigger :placeholder-shown styles
                    className={`custom-datepicker ${selectedDate ? 'has-value' : ''}`}
                  />
                  <label className={selectedDate ? 'active' : ''}><span className='required'>*</span>From Date</label>
                </div>

                <div className="leavemanagement-div-floating-label">
                  <DatePicker
                    selected={selectedEndDate}
                    onChange={(date) => setSelectedEndDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=" " // needed for :placeholder-shown behavior
                    className={`custom-datepicker ${selectedEndDate ? 'has-value' : ''}`}
                    minDate={selectedDate}
                    disabled={!selectedDate}
                  />
                  <label className={selectedEndDate ? 'active' : ''}><span className='required'>*</span>To Date</label>
                </div>

                <div className="leavemanagement-div-floating-label">
                  <Select
                    placeholder=" " // required to trigger label float logic
                    isClearable
                    options={leaveTypeOptions}
                    value={selectedLeaveType}
                    onChange={setSelectedLeaveType}
                    classNamePrefix="floating-select"
                    className={`floating-select-wrapper ${selectedLeaveType ? 'has-value' : ''}`}
                  />
                  <label className={selectedLeaveType ? 'active' : ''}><span className='required'>*</span>Leave Type</label>
                </div>

                <div className="leavemanagement-div-floating-label">

                  <input
                    type="text"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder=''
                  />
                  <label>Reason</label>
                </div>
                <div className="leavemanagement-div-floating-label">

                  <input
                    type="text"
                    value={remainingLeaves}
                    readOnly
                    className="readonly-input"
                  />
                  <label>Leave Balance </label>
                </div>

                <div className='leaves-bbttnn'>
                  <div><button type="submit" className="leave-button-submit" disabled={!isFormValid}>Submit</button></div >
                  <div><button type="button" className="leave-button-clear" onClick={clearForm}>Clear</button></div>
                  <div> <button type="button" className="leave-button-close" onClick={gotoDashBoard} >Close</button></div>
                </div>


              </form>
            )}

            {/* Display Holiday Data in a Table */}
            <div>
              {/* <div className='leavemangement-div-leaves'>
              <div className="leavemanagement-div">
                <label>Max Leaves: </label>
                <input type="text" 
                value={totalLeaves}
                readOnly
                style={{
                  pointerEvents: 'none',
                  userSelect: 'none',
                  color: 'gray',
                  backgroundColor: 'transparent',
                }}/>
              </div>
              
            </div> */}
              <h3 className="leavetable-heading">Leave List</h3>
              <div className="leave-table">
                <table className="leavemanagement-table">
                  <thead>
                    <tr>
                      <th> S.No </th>
                      {/* <th>Emp Id</th> */}
                      <th>Name</th>
                      <th>From Date</th>
                      <th>To Date</th>
                       <th>No of Days</th>
                      <th>Leave Type</th>
                      <th>Reason</th>
                      <th>Status</th>
                      <th>Remarks</th>
                      <th>Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    {getAllHolidays.length === 0 ? (
                      <tr><td colSpan="10">No leaves found</td></tr>
                    ) : (
                      getAllHolidays.map((leaves, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {/* <td>{leaves.employeeId}</td> */}
                          <td>{leaves.employeeName}</td>
                          <td>{format(new Date(leaves.fromDate), 'dd-MM-yyyy')}</td>
                          <td>{format(new Date(leaves.toDate), 'dd-MM-yyyy')}</td>
                          <td>{leaves.daysApplied}</td>
                          <td>{leaves.type}</td>
                          <td>{leaves.reason}</td>
                          <td>{leaves.status}</td>
                          <td>{leaves.remarks}</td>
                          <td>
                            {leaves.status === "APPLIED" && (
                              <button
                                onClick={() => handleCancelLeave(leaves.id)}
                                style={{
                                  backgroundColor: "skyblue",
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  color: "white"
                                }}
                              >
                                Cancel
                              </button>
                            )}

                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>

                </table>
              </div>
              {/* <div >
                <h3 className="leavetable-heading">Approved Leaves</h3>
                <div className="leave-table">
                  <table className="leavemanagement-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Employee Id</th>
                        <th>Employee Name</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Count</th>
                        <th>Type</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {approvedLeaves.map((leave, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{leave.employeeId}</td>
                          <td>{leave.employeeName}</td>
                          <td>{format(new Date(leave.fromDate), 'dd-MM-yyyy')}</td>
                          <td>{format(new Date(leave.toDate), 'dd-MM-yyyy')}</td>
                          <td>{leave.daysApplied}</td>
                          <td>{leave.type}</td>
                          <td>{leave.reason}</td>
                          <td>{leave.status}</td>
                          <td><button
                            onClick={() => {
                              setShowForm(true);
                              setIsEditMode(true);
                              setEditLeaveId(leave.id); // This is crucial
                              setApprovedLeaveId(leave.approvedId || leave.id);
                              setSelectedDate(new Date(leave.fromDate));
                              setSelectedEndDate(new Date(leave.toDate));
                              setSelectedLeaveType(leaveTypeOptions.find(opt => opt.label === leave.type));
                              setReason(leave.reason);
                            }}
                            style={{ backgroundColor: "skyblue", border: "1px solid black", borderRadius: "5px", color: 'white' }}
                          >
                            Update
                          </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LeaveRequest;
